import { useBilling } from '@/contexts/BillingContext'
import { Clock } from 'lucide-react'

interface TrialBannerProps {
  orgSlug: string
  onSubscribe?: () => void
}

export function TrialBanner({ orgSlug, onSubscribe }: TrialBannerProps) {
  const { billing } = useBilling()

  if (!billing || billing.status !== 'trialing' || billing.trial_days_remaining == null) {
    return null
  }

  const days = billing.trial_days_remaining
  const isUrgent = days <= 3

  const message =
    days === 0
      ? 'Tu prueba gratis termina hoy.'
      : days === 1
        ? 'Te queda 1 día de prueba gratis.'
        : `Te quedan ${days} días de prueba gratis.`

  const handleClick = () => {
    if (onSubscribe) {
      onSubscribe()
    } else {
      window.location.href = `/${orgSlug}/settings?billing=upgrade`
    }
  }

  return (
    <div className={`${isUrgent ? 'bg-yellow-500/10 border-b border-yellow-500/20' : 'bg-blue-500/10 border-b border-blue-500/20'} px-4 py-2`}>
      <div className="flex items-center justify-between max-w-7xl mx-auto">
        <div className={`flex items-center gap-2 text-sm ${isUrgent ? 'text-yellow-600' : 'text-blue-600'}`}>
          <Clock className="h-4 w-4" />
          <span>{message}</span>
        </div>
        <button
          onClick={handleClick}
          className={`text-sm font-medium underline ${isUrgent ? 'text-yellow-600 hover:text-yellow-700' : 'text-blue-600 hover:text-blue-700'}`}
        >
          Suscribirse
        </button>
      </div>
    </div>
  )
}
